export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';

export const FETCH_SETTING = 'FETCH_SETTING';
export const FETCH_SETTING_SUCCESS = 'FETCH_SETTING_SUCCESS';
export const FETCH_SETTING_FAILURE = 'FETCH_SETTING_FAILURE';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const UPDATE_PROJECT_SETTING = 'UPDATE_PROJECT_SETTING';